import { PackageUseProxyFormView } from '../view/PackageUseProxyFormView';
import { templatePackageDeployerForm } from '../view/template';
import { BaseWebComponentController, IListenerConfig } from '../../../../framework/BaseWebComponentController';
import { PackageUseProxyFormWebComponent } from '../component/PackageUseProxyFormWebComponent';
import { toggleVisibility } from '../../../../utils/htmlElement.utils';
import { UseProxyFormViewMetadata } from '../types';
import { InputEvents } from '../../../../ui/gzInput/types';

export class PackageUseProxyFormController extends BaseWebComponentController {
  public view: PackageUseProxyFormView;
  public viewConstructor: typeof PackageUseProxyFormView;
  public component: PackageUseProxyFormWebComponent;

  constructor(component: PackageUseProxyFormWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: PackageUseProxyFormView,
      viewTemplate: templatePackageDeployerForm,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$useProxyCheckbox,
        event: InputEvents.CHANGE,
        callback: this.displayUseProxyFields,
      },
      {
        element: this.view.dom.$usernameProxyFormField,
        event: InputEvents.CHANGE,
        callback: this.updateValidationPassword,
      },
      {
        element: this.view.dom.$passwordProxyFormField,
        event: InputEvents.CHANGE,
        callback: this.updateValidationUsername,
      },
      {
        element: this.view.dom.$passwordProxyFormField.Input,
        event: 'click',
        callback: this.clearInputOnInteraction,
      },
    ];
  }

  private clearInputOnInteraction(): void {
    this.view.dom.$passwordProxyFormField.value = '';
  }

  private updateValidationUsername(): void {
    this.view.dom.$usernameProxyFormField.validate();
  }

  private updateValidationPassword(): void {
    this.view.dom.$passwordProxyFormField.validate();
  }

  private displayUseProxyFields(): void {
    toggleVisibility(this.view.dom.$proxySectionChecked, this.view.dom.$useProxyCheckbox.value);
    this.view.addValidationPortServerUserPass(this.view.dom.$useProxyCheckbox.value);
  }

  public async companyChangeHandler(): Promise<void> {
    this.resetUseProxyFormField();
  }

  private resetUseProxyFormField(): void {
    this.view.resetProxyFieldsState();
    this.displayUseProxyFields();
  }

  async getDataForView(): Promise<UseProxyFormViewMetadata> {
    return {
      context: this.component.formContext,
      packageData: this.component.packageData,
    };
  }
}
